const baseColors = {
	primary: "#ea7a78",
	another: "#e66462",
};

export default baseColors;